// import { Component } from '@angular/core';

// @Component({
//   selector: 'app-sm-select-all',
//   templateUrl: './sm-select-all.component.html',
//   styleUrls: ['./sm-select-all.component.scss']
// })
// export class SmSelectAllComponent {

// }

import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  forwardRef,
} from "@angular/core";
import {
  ControlContainer,
  FormGroupDirective,
  NG_VALUE_ACCESSOR,
} from "@angular/forms";
import { SmUiComponent } from "../sm-ui/sm-ui.component";

@Component({
  selector: 'sm-select-all',
  templateUrl: './sm-select-all.component.html',
  styleUrls: ['./sm-select-all.component.scss'],
  viewProviders: [
    { provide: ControlContainer, useExisting: FormGroupDirective },
  ],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SmSelectAllComponent),
      multi: true,
    },
  ],
})
export class SmSelectAllComponent
  extends SmUiComponent
  implements OnInit, OnChanges
{
  @Input() options;
  @Output() selected = new EventEmitter<any>();
  @Output() filteredState = new EventEmitter<any>();
  isDisable: boolean = true;

  override ngOnInit(): void {
    super.ngOnInit();
    // console.log(this.props);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["options"]) {
      this.options = [
        { student_id: "selectAll", name: "Select All", id: "selectAll" },
        ...this.props.options,
      ];
      // console.log("Options changed:", this.props.options);
    }
  }

  onMaterialGroupChange(event: any): any {
    // Handle the case when items are selected/deselected normally
    const selectedValues = event || [];
    
    // Update the "Select All" checkbox state based on selections
    if (selectedValues.length === this.options.filter(opt => opt.student_id !== "selectAll").length) {
      const selectAllOption = this.options.find(opt => opt.student_id === "selectAll");
      if (selectAllOption && !selectedValues.includes(selectAllOption.id)) {
        selectedValues.push(selectAllOption.id);
      }
    }

    this.selected.emit(selectedValues);
    return selectedValues;
  }

  onSelectAllChange(event: any, ngSelect: any): void {
    event.stopPropagation(); // Stop event propagation

    const isChecked = !this.areAllSelected();

    if (isChecked) {
      const allOptionValues = this.options
        .filter((option) => option.student_id !== "selectAll")
        .map((option) => option.id);
      this.formcontrol.patchValue(allOptionValues);
      this.onMaterialGroupChange(allOptionValues);
    } else {
      this.formcontrol.patchValue([]);
      this.onMaterialGroupChange([]);
    }
}

  areAllSelected(): boolean {
    const selectedValues = this.formcontrol.value || [];
    const optionValues = this.options
      .filter((option) => option.student_id !== "selectAll")
      .map((option) => option.id);
    
    return optionValues.length > 0 && 
           optionValues.every((value) => selectedValues.includes(value));
  }

  handleKeyDown(event: KeyboardEvent, ngSelect: any): void {
    if (event.key === 'Enter') {
      event.preventDefault();
      event.stopPropagation();
      this.onSelectAllChange(
        { 
          preventDefault: () => {},
          stopPropagation: () => {},
          target: { checked: !this.areAllSelected() } 
        }, 
        ngSelect
      );
    }
  }

  filterEmitter(event: any): void {
    this.props.filterOptions.forEach((filter) => {
      if (filter.id === event.target.id) {
        filter.state = event.target.checked;
      }
    });
    this.filteredState.emit(this.props.filterOptions);
  }
}
